import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { Component, OnInit } from "@angular/core";
import { LoaderService } from './services/loader.service'

@Component({
  selector: 'app-redirect',
  templateUrl: 'onemomentplease.html'
})
export class RedirectComponent implements OnInit {
  constructor(private router: Router, public http: HttpClient, private loaderService: LoaderService) { }
    //everythong poasses through here so set up the localstorage... 
    public ngOnInit(): any {
       this.loaderService.emitChange(true);
       localStorage.removeItem('Shop');
        //console.log('RedirectComponent')
      this.http.get('/Users/AuthedUser').subscribe((res: any) => {
        this.loaderService.emitChange(false);

        switch (res?.Role) {// there can only be one role
          case "Manager":
            this.router.navigate(['choose'])
            break;
          case "specsaversadmin":
            this.router.navigate(['admin'])
            break;
          case "specsaverslogistics":
            this.router.navigate(['admin'])
            break;
          case "citipostadmin":
            this.router.navigate(['admin'])
            break;
          case "citipostsuperadmin":
            this.router.navigate(['admin'])
            break;
          case "trakiiadmin":
            this.router.navigate(['trakii'])
            break;
          case "lensdispatchadmin":
            this.router.navigate(['lensdispatch'])
            break;
          default:
            //which shop
            if (res.Shop == "") {
              this.router.navigate(['noshop'])
            }
            else { 
              localStorage.setItem("Shop", res.Shop);
              this.router.navigate(['shopservices'])
            }
          }
    
        
        });


   }
}
